export default __webpack_public_path__ + "static/media/defaultDp.a6143582.png";